import React from 'react';

export interface TabItem {
  id: string;
  label: string;
  icon?: React.ReactNode;
  path?: string;
}

interface DetailsTabsProps {
  tabs: TabItem[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

export const DetailsTabs = ({ tabs, activeTab, onTabChange }: DetailsTabsProps) => {
  return (
    <div className="dark:border-gray-1000 border-b border-gray-200">
      <div className="flex">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`relative px-4 py-4 text-sm font-medium ${
              activeTab === tab.id
                ? 'font-extrabold text-gray-800 after:absolute after:right-0 after:bottom-[-1px] after:left-0 after:h-[2px] after:bg-gray-800 dark:text-white dark:after:bg-gray-200'
                : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
            }`}
            onClick={() => onTabChange(tab.id)}>
            <span className="flex items-center">
              {tab.icon}
              {tab.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};
